import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { FormControl,FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltrosDocumentosNegociables } from '../../../models/FiltrosDocumentosNegociables';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
declare var $: any;
@Component({
  selector: 'app-listado-financiamiento',
  templateUrl: './listado-financiamiento.component.html',
  styleUrls: ['./listado-financiamiento.component.css']
})
export class ListadoFinanciamientoComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  archivoEnBase64 : any;
  tipoAdjunto : number;
  DNegociable : any;
  adjuntarPDF : boolean;
  selectArchivo : boolean;
  ruc = new FormControl();
  rucAdq = new FormControl();
  tipoComprobante :string;
  formExtornar: FormGroup;
  estado ="A";
  id  ="0";
  idAdq  ="0";
  adjuntoEstado : string ='T';
  filteredProveeedor: Observable<any[]>;
  filteredAdquirente: Observable<any[]>;
  proveedoresArr;
  adquirentesArr;
  tipoEmsion:string ;
  ruta : string;
  isRecibo:boolean = true;
  isLetra:boolean = true;
  user :any;
  idEncrip:any;
  
  relacionDNF: boolean;
  comprobante:any;
  fondos: any = [];
  garantias: any = [];  
  arraySend: any = [];

  
  isRiesgo: boolean = false;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','Serie','Número','NombreComercial','RazonSocialAdquirente','Fondo','Fecha_Emision',
            'Fecha_de_Pago','Moneda','VNPP','Estado','Fecha_Proceso','Codigo_Valor','Estado_Cavali'];
  dataSource :any; 
   DTOFiltrosDocNeg :FiltrosDocumentosNegociables = new FiltrosDocumentosNegociables();
   
  readonly ROLE_ADMIN: number = environment.ROLE_ADMIN_ID;
  readonly ROLE_RIESGO: number = environment.ROLE_RIESGO_ID;
  readonly ROLE_OPERACIONES: number = environment.ROLE_OPERACIONES_ID; // Rol Riesgo desde bd SecurityDBDev
  constructor( private negociablesService:DocumentoNegociableService,
               private riesgo: RiesgoService,  
               private empresasService: EmpresasService, 
               private cavaliService : CavaliService,
               private router:Router,
               private loginService:LoginService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.adjuntarPDF = false;
    this.selectArchivo = false;
    this.cargarListadoCompleto();
    this.ObtenerEmpresasCombo(); 
    this.ObtenerEmpresasComboAdq();  
    this.listarFondos();  
    
     this.userHasValidRole([this.ROLE_ADMIN, this.ROLE_RIESGO, this.ROLE_OPERACIONES]);
   }
  ngOnInit() {
    
    let rutas = this.router.url.split("/",3);
    this.ruta = rutas[2];
    this.DTOFiltrosDocNeg.Estado = 'A';
    //
   //  this.idEncrip=CryptoJS.MD5(this.user.id_user.toString().trim()).toString(); 
    /*this.idEncrip=Buffer.from(this.user.id_user.toString()).toString('base64');*/
   // this.DTOFiltrosDocNeg.user_id=this.idEncrip;
  }
  userHasValidRole(id_roles: number[]) {
    if(!id_roles.includes(this.user.id_roles)){
      this.displayedColumns = 
            ['Serie','Número','NombreComercial','RazonSocialAdquirente','Fondo','Fecha_Emision',
            'Fecha_de_Pago','Moneda','VNPP','Estado','Fecha_Proceso','Codigo_Valor','Estado_Cavali'];
    };
  }
  CerrarVenta(){
   
    this.selectArchivo = false;
   
 }

   CerrarVentaAdjunto(){
   
    this.adjuntarPDF = false;
    this.filtradoDocNegociables();
 
  }  
  cerrarPopUp() {
    this.relacionDNF = false;
  }
  abrirRelacionDNF(comprobante, flag) {
   
    
      this.comprobante = ""; 
      
      this.arraySend.push(comprobante);
      this.relacionDNF = true;
      
  }
  listarFondos() {
    this.riesgo.obtenerFondos().subscribe(
      resp => {
        this.fondos = resp
       // this.fondos = this.fondos.filter(item => item.Moneda == this.PropuestaOperacion.Moneda || item.Multiples_Moneda == 'A');
      }, (err: HttpErrorResponse) => {
        this.loading = false;       
        
        Swal.fire({
          title: 'error',
          text: "LISTA FONDOS NO OBTENIDO. ",
          type: "error",
          allowOutsideClick: false
        });
      });
  }

  abrirSelecTipoArchivo(fila : string , tipoEmision?: string){
    if (tipoEmision =='Electrónico'){
      
      this.tipoEmsion='E';
    }else{
      this.tipoEmsion='F'
    }
    this.selectArchivo = !this.selectArchivo;
    this.DNegociable = fila;
  }

  abrirAdjuntarPDF(data : any ){
    this.negociablesService.dataNegociable = data;
    this.adjuntarPDF = true;
 

  
  }

  darBajaDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro en dar de baja el documento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('B'),
          'Baja_Usuario': new FormControl(this.user.Usuario)
        })  
        this.riesgo.actualizarDocumento(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire(
            '¡Documento dado de baja!',
            'El documento fue dado de baja exitosamente.',
            'success'
          ).then(resp => {
            if (resp.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo dar de baja el documento.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      }
    })
  }
  
  RetirarDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro en retirar el documento del Fondo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, retirar',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('R'),
          'Baja_Usuario': new FormControl(this.user.Usuario)
        })  
        this.riesgo.actualizarDocumento(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire(
            '¡Documento retirado!',
            'El documento fue retirado exitosamente.',
            'success'
          ).then(resp => {
            if (resp.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo retirar el documento.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      }
    })
  }
  
  ExtornarDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de extornar el documento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, extornar',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('R',)
        })  
        this.negociablesService.actualizarDocNegociable(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire({
            title: '¡Documento extornado!',
            text: 'El documento fue extornado exitosamente.',
            type: 'success',
            heightAuto: false
          }).then(resp1 => {
            if (resp1.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo extornar el documento.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      } 
    })

  }

  EditarDocumento(id : string , tipoEmision?: string){

    if(this.isRecibo){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/recibo/RH/editar/',id]);
    }
    else if(this.isLetra){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/letra/LC/editar/',id]);
    }
    else{
      if(tipoEmision == "Físico"){
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FF/editar/',id]);
      }else{
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FE/editar/',id]);
      }
    }
  }

  verDocumento(id : string , tipoEmision?: string){
    if(this.isRecibo){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/recibo/RH/ver/',id]);
    }
    else if(this.isLetra){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/letra/LC/ver/',id]);
    }
    else{
      if(tipoEmision == "Físico"){
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FF/ver/',id]);
      }else{
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FE/ver/',id]);
      }
    }
  }
  
  cargarListadoCompleto(){
    this.loading = true;
    this.riesgo.obtenerReporte().subscribe(
      res => {
        this.docNegociables = res;

        this.docNegociables = this.docNegociables.filter(elem => elem.Estado_Financiamiento_Fondo == "Activo")
        this.dataSource = new MatTableDataSource( this.docNegociables);
        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }
    )
  /*  this.negociablesService.obtenerDocNegociables()
    .subscribe(res => {
      
      this.docNegociables = res;
      console.log("documentos negociables",res);
      this.negociablesService.dataNegociables = this. docNegociables ;
      this.loading = false;
      this.docNegociables = this.docNegociables.filter(elem => elem.Estado_Financiamiento_Fondo == "A")
      this.dataSource = new MatTableDataSource( this.docNegociables);
      console.log("Resultado de data source",this.dataSource);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      
    });*/
  }

  alerta(){
    alert('asd');
  }
  
  filtradoDocNegociables(){
    this.loading = true;
    
    let data = {
      "proveedor":this.id,
      "adquirente":this.idAdq,
      "estado":this.DTOFiltrosDocNeg.Estado,
      "numero":this.DTOFiltrosDocNeg.Numero,
      "Tipo_Emision":this.DTOFiltrosDocNeg.Tipo_Emision
    }
 
    this.riesgo.obtenerReporteFiltros(data)
    .subscribe( resp => { 
      this.docNegociables = resp
      this.negociablesService.dataNegociables = this. docNegociables ;
      this.dataSource = new MatTableDataSource(this.docNegociables); 
      console.log("DATOS FILTRADOS",this.dataSource)     
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.pageSizeOptions = [15,20,30,50,100,200];
      this.loading = false;

    })

  }

  ObtenerEmpresasCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo')); 

      this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      ); 
   
  }
  
  ObtenerEmpresasComboAdq() { 
    
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

     
      this.filteredAdquirente = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentesArr.slice()
        )
      );
  
   
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => (state.Razon_Social.toLowerCase().includes(filterValue) === true) ||  (state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true)
    );
  }
 

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  obtenerId(termino :string){
    this.id = termino
    this.DTOFiltrosDocNeg.Id = termino;
  }
  obtenerIdAdq(termino :string){
    this.idAdq = termino
    this.DTOFiltrosDocNeg.IdAdq = termino;
  }
  resetProveedor(){    
    this.id = "0";
  }
  resetAdquirente(){    
    this.idAdq = "0";
  }
  EnterobtenerRucRazSocialProv(termino :string = ''){
    
    if (termino != null && termino != ''){
     
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.proveedoresArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            this.DTOFiltrosDocNeg.Id = p.idEmpresa;
          }
  
      }

    }

  }
  
  EnterobtenerRucRazSocialAdq(termino :string = ''){
    
    if (termino != null && termino != ''){
     
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.adquirentesArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.idAdq = p.idEmpresa;
            this.DTOFiltrosDocNeg.IdAdq = p.idEmpresa;
          }
  
      }

    }

  }
  
  TransferirCavali(idComprobante){
    Swal.fire({
      title: 'Factrack - Cavali',
      text: '¿Deseas transferir el documento Nro. '+ idComprobante+' al proceso de "traspaso" en la plataforma Cavali?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.cavaliService.traspasoCavali(idComprobante).subscribe( res => {
          let rpt = res['data'];
          this.showNotification('success','top','right','Documento Nro. '+ idComprobante + ' ' + rpt);
        }, err => {
          let error = "";
          if(err.status == "406"){
            error = err.error.data;
          } else {
            error = err.error.error;
          }      
          this.showNotification('danger','top','right','Error al intentar traspasar documento en Cavali. \n' + error);
        });
        Swal.fire({
          title: 'Satisfactorio!',
          text: 'Documento Nro. '+ idComprobante+' ha sido enviado para su traspaso en Cavali.',
          type: 'success',
          heightAuto: false
        })
      }
    })
  }

  
  reactivarDocumento(idComprobante){
    Swal.fire({
      title: 'Reactivar',
      text: '¿Deseas reactivar el documento Nro. '+ idComprobante+'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        let data = {
          'idComprobante':idComprobante
        }
        this.riesgo.reactivarDocumento(data,idComprobante).subscribe( res => {
          let rpt = res['data'];
          this.showNotification('success','top','right','Documento Nro. '+ idComprobante + ' ' + rpt);
        }, err => {
          let error = "";
          if(err.status == "406"){
            error = err.error.data;
          } else {
            error = err.error.error;
          }      
          this.showNotification('danger','top','right','Error al intentar reactivar el documento. \n' + error);
        });
        Swal.fire({
          title: 'Satisfactorio!',
          text: 'Documento Nro. '+ idComprobante+' ha sido reactivado, puede volver a asignar.',
          type: 'success',
          heightAuto: false
        })
      }
    })
  }

  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
